import {getData } from "./core";

export default class LandingPurchaseTicketApi {
  static uri = "/n/internet/landingPurchaseTicket";
  get(id: number) {
    return getData({
      uri: LandingPurchaseTicketApi.uri,
      id: id
        });
  }
}